export default __webpack_public_path__ + "static/media/cart_empty_state.f0535868.svg";